import type { ProductCardProps } from '@coursera/cds-core';

import type { getExperimentalStatusTagForSlug } from 'bundles/product-card/components/utils/copyTestUtils';
import { useProductCardRedesign } from 'bundles/product-card/components/utils/copyTestUtils';

export const getStatusTagRedesignExperimentVariant = () => ({
  isBorderlessCard: false,
});

export const useStatusTagRedesignExperimentVariant = (
  slug?: string
): {
  statusTagRedesignVariant: 'control' | 'A';
  productCardExperimentVariant: ProductCardProps['experimentVariant'];
  isBorderlessCard: boolean;
  statusTag: ReturnType<typeof getExperimentalStatusTagForSlug>;
} => {
  const {
    experimentVariant,
    shouldUseExperimentalStatusTags: isRolloutRunning,
    statusTag,
  } = useProductCardRedesign(slug);

  const showRedesignedCard = isRolloutRunning && experimentVariant !== 'control';
  const productCardExperimentVariant: ProductCardProps['experimentVariant'] = showRedesignedCard
    ? 'test1.5'
    : 'control';

  return {
    statusTagRedesignVariant: showRedesignedCard ? 'A' : 'control',
    productCardExperimentVariant,
    isBorderlessCard: false,
    statusTag,
  };
};
